/**
 * 線形関数のイージング関数
 *
 * @param {Number} t 経過時間 0..1
 * @returns {Number} 進行度を返す
 */
export function linear (t) {
  return t
}
